import MapYandex from './YandexMap';

export default MapYandex;
